"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSomePermission = exports.hasEveryPermission = void 0;
var intersection_1 = __importDefault(require("lodash/intersection"));
var isEqual_1 = __importDefault(require("lodash/isEqual"));
/**
 * Returns true if
 * there are no required permissions
 * all of the required permissions exist in the user's permissions
 *
 * @param {string[]} permissions The permissions that the logged in user has
 * @param {string[]} requiredPermissions The permissions required to access a piece of functionality
 */
var hasEveryPermission = function (permissions, requiredPermissions) {
    return !requiredPermissions || (0, isEqual_1.default)((0, intersection_1.default)(requiredPermissions, permissions), requiredPermissions);
};
exports.hasEveryPermission = hasEveryPermission;
/**
 * Returns true if
 * there are no required permissions
 * any of the required permissions exist in the user's permissions
 *
 * @param {string[]} permissions The permissions that the logged in user has
 * @param {string[]} requiredPermissions The permissions required to access a piece of functionality
 */
var hasSomePermission = function (permissions, requiredPermissions) {
    return !requiredPermissions || (0, intersection_1.default)(requiredPermissions, permissions).length > 0;
};
exports.hasSomePermission = hasSomePermission;
